import store from '@/store/store';
import HttpRequest from '@/../bower_components/teknisavuecomponents/assets/utils/HttpRequest';
import SnackbarUtils from '@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils';

class CommonRequests {
  public static async getVinculosDoGestor(
    showLoading = true,
    nrEstrutura?: string,
    dtCompetencia?: string,
  ) {
    const user = store.getters.user;
    const estrutura = store.getters.estruturaGerencialAtual;

    const nrPeriodo = store.getters.getNrperiodoApuracaoAtual;
    nrEstrutura = nrEstrutura || estrutura && estrutura.NRESTRUTURAM;
    const nrOrg = user.nrorg;
    const nrVinculo = user.nrvinculom;

    const route = 'getVinculosDoGestor';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRPERIODOAPURACAO: nrPeriodo,
      NRESTRUTURAM: nrEstrutura,
      NRVINCULOM: nrVinculo,
      DTMESCOMPETENC: dtCompetencia,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const vinculos: any[] = response.data.dataset.data;

      vinculos.forEach((vinculo) => {
        if (vinculo.DTADMISSAOVINC) {
          vinculo.DTADMISSAOVINC = vinculo.DTADMISSAOVINC.split(' ')[0];
        }
      })

      return vinculos;
    } catch (err) {
      const message = 'Não foi possível carregar os vínculos!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

  public static async getValorReferencia(
    dsReferencia: string,
    showLoading = true,
    timeoutCancel = null
  ) {
    const nrOrg: string = store.getters.user.nrorg;
    const route = 'getValorReferencia';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      DSREFERENCIA: dsReferencia,
    };

    const response = await HttpRequest.get(route, params, showLoading, null, true, null, timeoutCancel);
    const valorReferencia: string = response.data.dataset.data.valor;

    return valorReferencia;
  }

  public static async getParcNegocioTodos(
    showLoading = true,
    nrEstrutura?: string,
  ) {
    const user = store.getters.user;
    const estrutura = store.getters.estruturaGerencialAtual;

    nrEstrutura = nrEstrutura || estrutura.NRESTRUTURAM;
    const nrOrg = user.nrorg;
    const nrVinculo = user.nrvinculom;

    const route = 'getParcNegocioTodos';

    const params = {
      requestType: 'FilterData',
      NRORG: nrOrg,
      NRESTRUTURAM: nrEstrutura,
      NRVINCULOM: nrVinculo,
    };

    try {
      const response = await HttpRequest.get(route, params, showLoading);
      const parcNegocioTodos: any[] = response.data.dataset.data;

      return parcNegocioTodos;
    } catch (err) {
      const message = 'Não foi possível carregar a relação dos Fornecedores!';
      SnackbarUtils.showMessage(message, SnackbarUtils.TYPE_ERROR);

      throw err;
    }
  }

}

export default CommonRequests;
